import { DateTimePickerField } from "@/components/DateTimePickerField";
import { useShiftDateMatcher } from "../hooks/useShiftDateMatcher";
import { DisplayTimesheetEntryContractorVisit } from "../types";

export const ShiftDateTimePickerField = ({
  row,
  field,
}: {
  row: { original: DisplayTimesheetEntryContractorVisit };
  field: "start_datetime" | "end_datetime";
}) => {
  const { getAllowedDatesMatcher } = useShiftDateMatcher();
  const shiftDate = new Date(row.original.shift_report_date);
  const datePickerProps = {
    disabled: getAllowedDatesMatcher(shiftDate, row.original.shift_name),
    defaultMonth: shiftDate,
  };

  return (
    <DateTimePickerField
      name={`entries.${row.original.id}.${field}`}
      datePickerProps={datePickerProps}
    />
  );
};
